module.exports = __webpack_public_path__ + "img/app_img2_1.249a5c5b.png";